/**
 * Designed  & Developed by Faisal Nadaf
 * Contact: faisalfnadaf@gmail.com
 *
 * @format
 */

import { Navigation } from "@/components/customCopmonent/landingSection/navigation";
import { FooterSection } from "@/components/customCopmonent/landingSection/footer-section";
import CircularGallery from "@/components/customCopmonent/CircularGallery";
import DotGrid from "@/components/customCopmonent/DotGrid";
import { PageHeaderHero, PAGE_HERO_CLASS } from "@/components/customCopmonent/Text/PageHeaderHero";
import { SectionWrapper } from "../Clientele.page-primitives";
import { PageHeader } from "@/components/customCopmonent/Text/PageHeader";
import { RevealOnScroll } from "@/components/SpecialProjectsPage.primitives";
import Seo from "@/components/Seo";
import { useIsMobile } from "@/hooks/hooks/use-mobile";

import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import {
	IndustrySectionProduct,
	IndustrySectionApplication,
} from "@/components/customCopmonent/IndustryCardsAP";

// Register ScrollTrigger
if (typeof window !== "undefined") {
	gsap.registerPlugin(ScrollTrigger);
}

const SUB_INDUSTRY_IMAGES = [
	"/images/industriesPhotos/Oil&Gas/SubIndustries/upstream.jpg",
	"/images/industriesPhotos/Oil&Gas/SubIndustries/midstream.jpg",
	"/images/industriesPhotos/Oil&Gas/SubIndustries/downstream.jpg",
	"/images/industriesPhotos/Oil&Gas/SubIndustries/lng-plants.jpg",
	"/images/industriesPhotos/PowerGeneration/SubIndustries/gas-power-plant.jpeg",
	"/images/industriesPhotos/Oil&Gas/SubIndustries/petrochemical-plants.jpg",
];

const APPLICATION_IMAGES = [
	"/images/industriesPhotos/Oil&Gas/Application/Process Fluid Cooling.webp",
	"/images/industriesPhotos/Oil&Gas/Application/Gas Compression Cooling.webp",
	"/images/industriesPhotos/Oil&Gas/Application/LNG Heat Exchanger.jpg",
	"/images/industriesPhotos/Oil&Gas/Application/Compressor Intercooling & Aftercooling.jpg",
	"/images/industriesPhotos/Oil&Gas/Application/Mechanical seal.webp",
	"/images/industriesPhotos/Oil&Gas/Application/Crude Oil Cooling & Heating.webp",
	"/images/industriesPhotos/Oil&Gas/Application/Refinery Heat Recovery Systems.webp",
];

const OilGas = () => {
	const { t } = useTranslation();
	const isMobile = useIsMobile();

	const subIndustryTexts = t("industryPages.oilGas.subIndustries.items", {
		returnObjects: true,
	}) as string[];
	const applicationItems = t("industryPages.oilGas.applications.items", {
		returnObjects: true,
	}) as { title: string; description: string }[];

	const pageData = {
		title: t("industryPages.oilGas.title"),
		bgimage: "/images/header/oilgas.jpg",
		description: t("industryPages.oilGas.tagline"),
		meta: t("industryPages.oilGas.meta", { returnObjects: true }) as string[],
		subIndustries: {
			title: t("industryPages.oilGas.subIndustries.title"),
			industries: SUB_INDUSTRY_IMAGES.map((image, i) => ({
				image,
				text: subIndustryTexts[i],
			})),
		},
		applications: {
			title: t("industryPages.oilGas.applications.title"),
			applications: APPLICATION_IMAGES.map((image, i) => ({
				image,
				title: applicationItems[i]?.title,
				description: applicationItems[i]?.description,
			})),
		},
	};

	return (
		<>
			<Seo
				titleKey="industryPages.oilGas.seo.title"
				descriptionKey="industryPages.oilGas.seo.description"
				path="/industries/oil-gas"
			/>
			<Navigation />
			<SectionWrapper className={PAGE_HERO_CLASS}>
				<div className="absolute inset-0 ">
					{" "}
					<div
						className="absolute bottom-3 inset-0 opacity-35 scale-105"
						style={{
							backgroundImage: `url(${pageData.bgimage})`,
							backgroundSize: "cover",
							backgroundPosition: "center",
						}}
					/>
					<DotGrid
						dotSize={4}
						gap={15}
						baseColor="#3b0092"
						activeColor="#f09a38"
						proximity={100}
						shockRadius={200}
						shockStrength={3}
						resistance={750}
						returnDuration={1.5}
					/>
				</div>
				<PageHeaderHero
					// align="center"
					title={pageData.title}
					description={pageData.description}
					meta={pageData.meta}
				/>
			</SectionWrapper>
			<SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				{" "}
				<div className="relative flex flex-col items-center justify-center ">
					{/* ===== HEADER ===== */}
					<RevealOnScroll>
						<PageHeader
							title={pageData.subIndustries.title}
							align="center"
							className="py-6 text-center items-center "
						/>
					</RevealOnScroll>
				</div>
				<div className="relative h-[360px] sm:h-[460px] lg:h-[600px]">
					<CircularGallery
						items={pageData.subIndustries.industries}
						textColor="#000"
						borderRadius={0.05}
						bend={isMobile ? 0 : -3}
						scrollSpeed={1.5}
						scrollEase={0.05}
					/>
				</div>
			</SectionWrapper>
			<SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				<IndustrySectionApplication
					applications={pageData.applications.applications}
					title={pageData.applications.title}
				/>{" "}
			</SectionWrapper>
			{/* <SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				<IndustrySectionProduct
					applications={pageData.products.products}
					title={pageData.products.title}
					description={pageData.products.description}
				/>
			</SectionWrapper> */}
			<FooterSection />
		</>
	);
};

export default OilGas;
